import { render, staticRenderFns } from "./VerticalWorkflowJobTabs.vue?vue&type=template&id=52a05f1c&"
import script from "./VerticalWorkflowJobTabs.vue?vue&type=script&lang=ts&"
export * from "./VerticalWorkflowJobTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports